<template>
  <drawer :opened.sync="opened" @close="onCloseBtnClick">
    <template #header>{{operatorTip}}{{editName}}</template>

    <template #body>
      <el-form ref="form" :model="model" label-width="120px" @keydown.native.enter.prevent="onSaveContinueBtnClick">
        <el-form-item
          label="污染源ID"
          prop="id"
          :rules="[{
            required: true,
            message: '请输入污染源id'
          }]"
        >
          <el-input v-model="model.id" placeholder="请输入污染源id" />
        </el-form-item>

        <el-form-item
          label="污染源名称"
          prop="name"
          :rules="[{
            required: true,
            message: '请输入污染源名称'
          }]"
        >
          <el-input v-model="model.name" placeholder="请输入污染源名称" />
        </el-form-item>

        <el-form-item
          label="污染源颜色"
          prop="color"
          :rules="[{
            required: true,
            message: '请选择污染源颜色'
          }]"
        >
          <el-input v-model="model.color" type="color" style="width:66px;" />
        </el-form-item>

        <el-form-item
          label="污染源备注"
          prop="note"
        >
          <el-input v-model="model.note" type="textarea" :autosize="{
            minRows: 7
          }" />
        </el-form-item>
      </el-form>
    </template>

    <template #footer>
      <el-button type="orange" class="btn save-btn" @click="onSaveBtnClick">保存</el-button>
      <a class="cancel-btn btn" @click="onCloseBtnClick">关闭</a>
    </template>
  </drawer>
</template>

<script>
import BaseEditor from '../../../BaseEditor'

export default {
  name: 'Editor',
  extends: BaseEditor,
  props: {
    sourceType: {
      required: true,
      type: Number
    }
  },
  methods: {
    initModel () {
      return {
        id: null,
        name: null,
        color: null,
        note: '',
        sourceType: this.sourceType
      }
    },
    getDetail (model) {
      this.onGetDetail()
      const data = JSON.parse(JSON.stringify(model))
      this.model = data
      this.clearFormValid()
      this.afterGetDetail(data)
    },
    save (callback, idKey) {
      let refForm = this.getForm()

      refForm && refForm.validate(flag => {
        if (!flag) {
          return
        }

        this.beforeSave()

        this.changeLoadStatus(true)

        this.$api[this.apiKey].save(this.model, this.operator).then(data => {
          this.$notify({
            title: '成功',
            message: '保存成功',
            type: 'success',
            position: 'bottom-right'
          })
          this.onSave(this.model)
          callback && callback(this.model)
        }).catch(console.error).finally(() => {
          this.changeLoadStatus(false)
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/views/09System-Settings/04Config/10PollutantSouce/Editor.vue